/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0MachineCreatePost$Json } from '../fn/machine/api-v-0-machine-create-post-json';
import { ApiV0MachineCreatePost$Json$Params } from '../fn/machine/api-v-0-machine-create-post-json';
import { apiV0MachineCreatePost$Plain } from '../fn/machine/api-v-0-machine-create-post-plain';
import { ApiV0MachineCreatePost$Plain$Params } from '../fn/machine/api-v-0-machine-create-post-plain';
import { apiV0MachineDeleteByIdDelete } from '../fn/machine/api-v-0-machine-delete-by-id-delete';
import { ApiV0MachineDeleteByIdDelete$Params } from '../fn/machine/api-v-0-machine-delete-by-id-delete';
import { apiV0MachineGetByCompanyGet$Json } from '../fn/machine/api-v-0-machine-get-by-company-get-json';
import { ApiV0MachineGetByCompanyGet$Json$Params } from '../fn/machine/api-v-0-machine-get-by-company-get-json';
import { apiV0MachineGetByCompanyGet$Plain } from '../fn/machine/api-v-0-machine-get-by-company-get-plain';
import { ApiV0MachineGetByCompanyGet$Plain$Params } from '../fn/machine/api-v-0-machine-get-by-company-get-plain';
import { apiV0MachineUpdatePost } from '../fn/machine/api-v-0-machine-update-post';
import { ApiV0MachineUpdatePost$Params } from '../fn/machine/api-v-0-machine-update-post';
import { Machine } from '../models/machine';

@Injectable({ providedIn: 'root' })
export class MachineService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0MachineGetByCompanyGet()` */
  static readonly ApiV0MachineGetByCompanyGetPath = '/api/v0/machine/getByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineGetByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineGetByCompanyGet$Plain$Response(params?: ApiV0MachineGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Machine>>> {
    const obs = apiV0MachineGetByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineGetByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineGetByCompanyGet$Plain(params?: ApiV0MachineGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<Machine>> {
    const resp = this.apiV0MachineGetByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Machine>>): Array<Machine> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineGetByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineGetByCompanyGet$Json$Response(params?: ApiV0MachineGetByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Machine>>> {
    const obs = apiV0MachineGetByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineGetByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineGetByCompanyGet$Json(params?: ApiV0MachineGetByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<Machine>> {
    const resp = this.apiV0MachineGetByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Machine>>): Array<Machine> => r.body)
    );
  }

  /** Path part for operation `apiV0MachineCreatePost()` */
  static readonly ApiV0MachineCreatePostPath = '/api/v0/machine/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineCreatePost$Plain$Response(params?: ApiV0MachineCreatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0MachineCreatePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineCreatePost$Plain(params?: ApiV0MachineCreatePost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0MachineCreatePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineCreatePost$Json$Response(params?: ApiV0MachineCreatePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0MachineCreatePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineCreatePost$Json(params?: ApiV0MachineCreatePost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0MachineCreatePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0MachineUpdatePost()` */
  static readonly ApiV0MachineUpdatePostPath = '/api/v0/machine/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineUpdatePost$Response(params?: ApiV0MachineUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0MachineUpdatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MachineUpdatePost(params?: ApiV0MachineUpdatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0MachineUpdatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0MachineDeleteByIdDelete()` */
  static readonly ApiV0MachineDeleteByIdDeletePath = '/api/v0/machine/deleteById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineDeleteByIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineDeleteByIdDelete$Response(params?: ApiV0MachineDeleteByIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0MachineDeleteByIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineDeleteByIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineDeleteByIdDelete(params?: ApiV0MachineDeleteByIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0MachineDeleteByIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
